<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" temporary absolute fixed width="200" id="drawer">
      <v-list>
        <v-list-tile @click="onClickMenuHome()">
          <v-list-tile-action>
            <v-icon color="#4C728A">home</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('side-menu.home') }}</v-list-tile-title>
        </v-list-tile>

        <v-list-tile v-if="!isZumiUser" @click="onClickJobkan()">
          <v-list-tile-action>
            <v-icon color="#4C728A">work</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>ジョブカン</v-list-tile-title>
        </v-list-tile>

        <v-list-tile v-if="!isZumiUser" @click="onClickFukutsu()">
          <v-list-tile-action>
            <v-icon color="#4C728A">local_shipping</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>福山通運</v-list-tile-title>
        </v-list-tile>

        <v-list-tile v-if="!isZumiUser" @click="onClickYamato()">
          <v-list-tile-action>
            <v-icon color="#4C728A">local_shipping</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>ヤマト運輸</v-list-tile-title>
        </v-list-tile>

        <v-list-tile v-if="isAdminUser" @click="onClickResourceReservation()">
          <v-list-tile-action>
            <v-icon color="#4C728A">event</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>会議室予約</v-list-tile-title>
        </v-list-tile>
        
        <v-list-tile v-if="isAdminUser" @click="onClickStoreDataAnalytics()">
          <v-list-tile-action>
            <v-icon color="#4C728A">analytics</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>店舗統計・分析</v-list-tile-title>
        </v-list-tile>        

        <v-list-tile v-if="isAdminUser" @click="onClickOcrAdminSalesReport()">
          <v-list-tile-action>
            <v-icon color="#2F80ED">insert_chart_outlined</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Sales report</v-list-tile-title>
        </v-list-tile>

        <v-list-tile v-if="isNormalUser" @click="onClickOcrUserSalesReport()">
          <v-list-tile-action>
            <v-icon color="#27AE60">add_a_photo</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Sales report</v-list-tile-title>
        </v-list-tile>

        <v-list-tile @click="onClickMenuLogout()">
          <v-list-tile-action>
            <v-icon color="#4C728A">logout</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>ログアウト</v-list-tile-title>
        </v-list-tile>
      </v-list>
     
    </v-navigation-drawer>
    
    <v-toolbar 
      class="app-toolbar"
      color="#4C728A"
      :to="{ name: 'home' }"
      v-bind:class="{ 'display-none': nonDispHeader }"
    >
      <!-- 왼쪽: 햄버거 -->
      <v-toolbar-side-icon 
        @click.stop="drawer = !drawer" 
        class="hidden-md-and-up">
      </v-toolbar-side-icon>

      <!-- 왼쪽: 로고 -->
      <!-- <img
        class="toolbar-logo"
        src="@/assets/images/mv-img-50th-pc_1.jpg"
        alt="HIROSOPHY"
      /> -->

      <div class="toolbar-center-title" @click="onClickHome()">
        {{ isAdminOperation ? $t('common.header-title-admin') : $t('common.header-title-user') }}
      </div>

      <v-spacer></v-spacer>

      <!-- <v-btn color="accent" large @click.stop="showResultDialog = true"></v-btn> -->
      <ResultDialog
        v-model="showResultDialogFlg"
        :message="resultDialogMessage"
        :forwardNameOnClose="resultDialogForwardNameOnClose"
        :isError="isError"
        :callbackAfterOnClose="callbackAfterOnClose"
        :response="response"
      />

      <!--언어선택-->
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>language</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="(item, index) in items"
            :key="index"
            @click="changeLanguage(item, index)"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-content grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-flex xs12>
          <!-- 서브 타이틀 -->
          <v-card
            flat
            class="title-bar"
            v-bind:class="{ 'display-none': nonDispHeader }"
          >
            <v-card-text class="px-0" id="page-title"></v-card-text>
          </v-card>
          <!-- 서브 타이틀 -->
          <router-view style="margin: 30px auto;"></router-view>
        </v-flex>
      </v-layout>
    </v-content>

    <!-- <v-footer
      app
      height="60"
      class="app-footer"
    >
      <v-container fluid>
        <v-layout row wrap align-center justify-space-between>
          <v-flex xs12 md6 class="text-left">
            © 2019 - {{ new Date().getFullYear() }} HIROSOPHY Co., Ltd.
          </v-flex>

          <v-flex xs12 md6 class="text-right">
            <span>All Rights Reserved. Internal Use Only</span>
          </v-flex>
        </v-layout>
      </v-container>
    </v-footer> -->

    <v-dialog v-model="showSimpleDialog" max-width="300px">
      <v-card>
        <v-container>
          <v-card-title>
            <span
              style="margin: 0 auto 0;"
              v-bind:class="{ 'font-error': isErrorSimpleDialog }"
            >{{ simpleDialogMessage }}</span>
          </v-card-title>
          <v-layout row wrap style="margin-bottom:20px;">
            <v-flex xs12 sm12>
              <v-btn color="primary" text @click="showSimpleDialog = !showSimpleDialog">Close</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>  
  import ResultDialog from '@/components/ResultDialog.vue'
  import ServerApiCallService from '@/services/ServerApiCallService.js'
  import { Validator } from 'vee-validate'
  import { mapState } from 'vuex'

  export default {
    name: 'App',
    data() {
      return {        
        nonDispHeader: false,
        showResultDialogFlg: false,
        resultDialogMessage: '',
        resultDialogForwardNameOnClose: '',
        isError: false,
        callbackAfterOnClose: null,
        response: null,
        drawer: null,
        showSimpleDialog: false,
        isErrorSimpleDialog: false,
        simpleDialogMessage: 'none error message',
        titleCache: '',
        items: [
          { title: '简体中文', lang: 'zhHans' },
          { title: '繁體中文', lang: 'zhHant' },
          { title: this.$t('lang-english'), lang: 'en' },
          { title: '日本語', lang: 'ja' }
        ],
        isAdminOperation: true
      }
    },
    computed: {
      isZumiUser() {
        const authority = this.$store.state.user && this.$store.state.user.adminRole
        return String(authority) === '9'
      },

      isNormalUser() {
        const authority = this.$store.state.user && this.$store.state.user.adminRole
        
        console.log("authority=============>: ", authority);        
        console.log("------------>", String(authority) === '0');
        
        return String(authority) === '0'


      },

      isAdminUser() {
        const authority = this.$store.state.user && this.$store.state.user.adminRole        
        return String(authority) === '1'
      },
    },
    components: {
      ResultDialog
    },
    methods: {
      onClickMenuLogout() {
        window.localStorage.removeItem('accessToken')
        if (this.$store.state.isAdminOperation === true) {
          this.$router.push({
            name: 'admin/new-admin-login'
          })
        } else if (this.$store.state.isAdminOperation === false) {
          this.$router.push({
            name: 'sales/new-user-login'
          })
        }
        // stateをクリア
        // this.$store.commit('clearAllState')
        this.$store.commit('CLEAR_SALES_SESSION')
        this.$store.commit('CLEAR_ADMIN_SESSION')
      },
      onClickJobkan() {
        this.drawer = !this.drawer
        window.open(
          'https://id.jobcan.jp/users/sign_in?app_key=atd&redirect_to=https://ssl.jobcan.jp/jbcoauth/callback'
        )
      },
      onClickFukutsu() {
        this.drawer = !this.drawer
        window.open('https://corp.fukutsu.co.jp/situation/tracking_no')
      },
      onClickYamato() {
        this.drawer = !this.drawer
        window.open('https://toi.kuronekoyamato.co.jp/cgi-bin/tneko')
      },
      onClickResourceReservation() {     
        this.drawer = !this.drawer
        ServerApiCallService.resourceReservation()
        .then(response => {
          if (response.data.errors.length > 0) {
            alert(response.data.errors[0].errorDescription)
            return;
          }

          let token = response.data.token
          let role = response.data.role
          let userId = response.data.userId

          if (token == '' || token == null ) {
            alert("Please contact your administrator")
            return
          }
          
          window.open('http://54.150.195.133?token='+token)
        })      
        .catch(error => {
          console.log('onClickResourceReservation error:', error.response)
        })
      },
      onClickStoreDataAnalytics() {     
        this.drawer = !this.drawer
        ServerApiCallService.storeDataAnalytics()
        .then(response => {
          if (response.data.errors.length > 0) {
            alert(response.data.errors[0].errorDescription)
            return;
          }

          let token = response.data.token
          let role = response.data.role
          let userId = response.data.userId

          if (token == '' || token == null ) {
            alert("Please contact your administrator")
            return
          }
          
          window.open('http://54.150.195.133/sas/analysis/Dashboard?token='+token)
        })      
        .catch(error => {
          console.log('onClickStoreDataAnalytics error:', error.response)
        })
      },
      onClickOcrAdminSalesReport() {
        this.drawer = !this.drawer
        ServerApiCallService.ocrSalesReport()
        .then(response => {
          if (response.data.errors.length > 0) {
            alert(response.data.errors[0].errorDescription)
            return;
          }

          let token = response.data.token
          let role = response.data.role
          let userId = response.data.userId

          if (token == '' || token == null ) {
            alert("Please contact your administrator")
            return
          }
          
          window.open('https://hirosophy-sales.com/dashboard?token='+token)
        })      
        .catch(error => {
          console.log('onClickOcrSalesReport error:', error.response)
        })
      },
      onClickOcrUserSalesReport() {
        this.drawer = !this.drawer
        ServerApiCallService.ocrSalesReport()
        .then(response => {
          if (response.data.errors.length > 0) {
            alert(response.data.errors[0].errorDescription)
            return;
          }

          let token = response.data.token
          let role = response.data.role
          let userId = response.data.userId

          if (token == '' || token == null ) {
            alert("Please contact your administrator")
            return
          }
          
          window.open('https://hirosophy-sales.com?token='+token)
        })      
        .catch(error => {
          console.log('onClickOcrSalesReport error:', error.response)
        })
      },
      onClickMenuHome() {
        this.drawer = !this.drawer
        this.onClickHome()
      },
      onClickHome() {
        if (this.$store.state.isAdminOperation === true) {
          this.$router.push({
            name: 'admin/new-admin-menu'
          })
        } else if (this.$store.state.isAdminOperation === false) {
          this.$router.push({
            name: 'sales/new-user-menu'
          })
        }
      },
      changeLanguage: function(item) {
        this.$i18n.locale = item.lang
        Validator.localize(item.lang)

        // set lang for state
        this.$store.commit('setSelectedLang', item.lang)

        // title change
        let title = this.$t(this.titleCache)
        document.title = title
        var pageTitleObj = document.getElementById('page-title')
        pageTitleObj.textContent = document.title
      },
      showDialog: function(message) {
        this.showSimpleDialog = true
        this.isErrorSimpleDialog = false
        this.simpleDialogMessage = message
      },
      showErrorDialog: function(message) {
        this.showSimpleDialog = true
        this.isErrorSimpleDialog = true
        this.simpleDialogMessage = message
      },
      showResultDialog: function(
        message,
        forwardNameOnClose,
        isError,
        callbackAfterOnClose,
        response
      ) {        
        this.showResultDialogFlg = true
        this.resultDialogMessage = message
        this.resultDialogForwardNameOnClose = forwardNameOnClose
        this.isError = isError
        this.callbackAfterOnClose = callbackAfterOnClose
        this.response = response
      },
      createPageTitle: function(to) {
        // タイトルを設定
        if (to.meta.titleKey) {
          this.titleCache = 'title.' + to.meta.titleKey
          let title = this.$t('title.' + to.meta.titleKey)
          document.title = title
          // var setTitle = to.meta.title
          // document.title = setTitle
          //        document.title = this.$t('sales-user-login')
        } else {
          document.title = 'non title'
        }

        var pageTitleObj = document.getElementById('page-title')
        pageTitleObj.textContent = document.title

        // メタタグdescription設定
        // if (to.meta.desc) {
        //   var setDesc = to.meta.desc + ' | SourceAcademy'
        //   document
        //     .querySelector("meta[name='description']")
        //     .setAttribute('content', setDesc)
        // } else {
        //   document
        //     .querySelector("meta[name='description']")
        //     .setAttribute('content', 'SourceAcademy')
        // }
      }
    },
    mounted: function() {
      var to = this.$route
      this.createPageTitle(to)
    },
    watch: {
      // $route(to, from) {
      $route(to) {
        if (to.meta.nonDispHeader) {
          this.nonDispHeader = true
        } else {
          this.nonDispHeader = false
        }
        this.createPageTitle(to)

        this.isAdminOperation = this.$store.state.isAdminOperation
      }
    }
  }
</script>
<style>
* {
  /* color: #2c3e50; */
}
#app, body {
  font-family: 'Hiragino Kaku Gothic Pro', 'メイリオ', 'Avenir', Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.v-list__tile__title {
  color: #2c3e50 !important;
}
.v-list__tile--link:hover {
  background: #ebeff3 !important;
}
#nav {
  padding: 30px;
}
button.hidden-md-and-up {
  display: block !important;
}
.v-btn__content .v-icon--left {
  margin-right: 8px;
}
.display-none {
  display: none !important;
}
.font-error {
  color: red;
}
.title-bar {
  background: linear-gradient(90deg, #6F8FA4 0%, #B7C9D5 100%);
  color: #ffffff;
  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.3);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  transition: background 0.3s ease;
}
#page-title {
  font-size: 16px !important;
  font-weight: 500;
  letter-spacing: 0.02em !important;
  font-family: Roboto, sans-serif !important;
  color: #ffffff !important;
  padding: 6px 0;
}
.app-toolbar {
  position: relative;
}
/* 로고는 툴바 높이에 맞춰 고정 */
.toolbar-logo {
  height: 90%;
  width: auto;
  margin-left: 8px;
  object-fit: contain;
  display: block;
}
.toolbar-center-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;

  font-size: 18px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  color: #111;
}

.app-footer {
  background: #4C728A;
  color: white;
  font-size: 14px;
}
</style>
